<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-2">Kapcsolat</h1>
      <b-row>
        <b-col cols="12" lg="6">
          <div class="bordered-container">
            <b-row cols="1" class="justify-content-md-center pt-2 mt-2">
              <b-col>
                <b-form>
                  <b-form-group id="input-group-1" label-for="input-1" description="">
                    <label for="name">Teljes név</label>
                    <b-form-input
                      id="name"
                      v-model="name"
                      type="text"
                      required
                      placeholder="Teljes név"
                      class="border"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="input-group-2" label-for="input-1" description="">
                    <label for="email">Email</label>
                    <b-form-input
                      id="email"
                      v-model="email"
                      type="email"
                      required
                      placeholder="Email cím"
                      class="border"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <label for="subject">Témakör</label>
                    <b-form-select v-model="subject" :options="options" id="subject"></b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <label for="message">Üzenet</label>
                    <b-form-textarea
                      id="message"
                      v-model="message"
                      placeholder="Üzenet"
                      rows="5"
                      class="text-box"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group class="text-left mt-4">
                    <b-button
                      type="submit"
                      variant="primary"
                      class="btn-100"
                      @click.prevent="onContactFormSubmit"
                      :disabled="isLoading"
                    >
                      <b-spinner small v-if="isLoading"></b-spinner>
                      <span class="sr-only" v-if="isLoading">Betöltés...</span>
                      <span v-if="!isLoading">Küldés</span>
                    </b-button>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-2 mb-3 mb-md-3 mt-3">
              <b-col class="ml-4 wrapper p-4">
                <h3 class="font-weight-bold mb-4 green">
                  Ügyfélszolgálatunk várja megkeresését
                  <br />
                  az alábbi elérhetőségeken:
                </h3>
                <h5 class="mb-2"><img class="mr-2" src="../assets/img/icons/homephone.svg" /> +36 1 312 2213</h5>
                <h5>
                  <img class="mr-2" src="../assets/img/icons/envelope.svg" />
                  <a href="mailto:info@mgfu.hu">
                    info@mgfu.hu
                  </a>
                </h5>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-modal ref="contact-email-sent" id="contact-email-sent" hide-header hide-footer @hide="onModalHide">
        <h4 class="text-center mb-5 mt-5">Sikeresen elküldte üzenetét!</h4>
        <div class="d-block text-center">
          <message-sent-svg />
          <div class="mt-5 text-center">
            Néhány munkanapon belül kollégánk<br />
            felveszi Önnel a kapcsolatot.
            <br /><br />
            <b-button @click="closeModal" variant="primary" class="mb-5">Bezárás</b-button>
          </div>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageSentSvg from '../components/svg/Contact/MessageSent'

export default {
  name: 'Contact',
  components: {
    MessageSentSvg
  },
  computed: {
    ...mapGetters(['isLoading'])
  },
  data() {
    return {
      email: '',
      name: '',
      message: '',
      subject: null,
      options: [
        {
          value: null,
          text: 'Témakör'
        },
        {
          value: '1',
          text: 'Segítség az oldal használatával kapcsolatban'
        },
        {
          value: '2',
          text: 'Probléma jelentése'
        },
        {
          value: '3',
          text: 'Kérdésem van a lehetőségekkel kapcsolatban'
        },
        {
          value: '4',
          text: 'Egyéb'
        }
      ]
    }
  },
  methods: {
    openModal() {
      this.$refs['contact-email-sent'].show()
    },
    closeModal() {
      this.$refs['contact-email-sent'].hide()
      this.$router.push('/')
    },
    onModalHide(e) {
      e.preventDefault()
    },
    async onContactFormSubmit() {
      const contactData = {
        email: this.email,
        subject: this.subject,
        name: this.name,
        message: this.message
      }
      if (
        !contactData.email.length ||
        !contactData.subject.length ||
        !contactData.name.length ||
        !contactData.message.length
      ) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az összes mező kitöltése kötelező!' }
        })

        return
      }

      await this.$store.dispatch('contact', contactData)
      this.openModal()
    }
  }
}
</script>

<style scoped>
.bordered-container {
  max-width: 600px;
  margin: 0;
  padding-left: 0px;
}
.green {
  color: #00903c;
}
.border {
  border: 2px solid #b2bec3 !important;
  border-radius: 4px !important;
}
.text-box {
  min-height: 185px;
}
.wrapper {
  background: #f2f8fa;
}
</style>
